export const UNDO_WINDOW_MS = 10_000;
